import { render, staticRenderFns } from "./TransfiyaBancaria.vue?vue&type=template&id=add90cae&scoped=true"
import script from "./TransfiyaBancaria.vue?vue&type=script&lang=js"
export * from "./TransfiyaBancaria.vue?vue&type=script&lang=js"
import style0 from "./TransfiyaBancaria.vue?vue&type=style&index=0&id=add90cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add90cae",
  null
  
)

export default component.exports